export class MissingFirebaseAuthEmulatorConfig extends Error {
  constructor() {
    super("Firebase Auth emulator configs are missing. Check .env file");
    this.name = "Firebase Auth emulator config missing";
  }
}
